import React from "react";
import {
    Card,
    CardBody,
    CardHeader,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap";
import ReactApexChart from "react-apexcharts";

const OrderReportEfficiency = () => {

    const efficiencyData = [
        { label: 'Nâu đá', value: 5 },
        { label: 'Sữa chua', value: 5 },
        { label: 'Sữa tươi', value: 6 },
        { label: 'Nước chanh', value: 7 },
        { label: 'Sữa dừa', value: 8 },
        { label: 'Cà phê sữa', value: 10 },
        { label: 'Cà phê đen', value: 12 },
        { label: 'Sữa bò', value: 12 },
    ];

    const series = [{
        name: 'Sessions',
        data: efficiencyData.map(item => item.value),
    }];

    const options: any = {
        chart: {
            type: 'bar',
            height: 436,
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                horizontal: true,
                distributed: false,  // Chỉ dùng một màu duy nhất
                dataLabels: {
                    position: 'top',
                },
            }
        },
        colors: ['#007bff'], // Sử dụng một màu duy nhất (có thể đổi nếu cần)
        dataLabels: {
            enabled: true,
            offsetX: 32,
            style: {
                fontSize: '12px',
                fontWeight: 400,
                colors: ['#adb5bd']
            }
        },
        legend: { show: false },
        grid: { show: false },
        xaxis: {
            categories: efficiencyData.map(item => item.label),
        },
    };

    return (
        <React.Fragment>
            <div className="page-content-wrapper py-3">
                <div className="container">
                    <Card>
                        <CardHeader>
                            <div className="d-flex">
                                <h5 className="card-title mb-0 flex-grow-1">Trung bình xử lý món</h5>
                                <div className="flex-shrink-0">
                                    <UncontrolledDropdown className="card-header-dropdown">
                                        <DropdownToggle
                                            className="text-reset dropdown-btn"
                                            tag="a"
                                            type="a"
                                            to="#"
                                        >
                                            <span className="fw-semibold text-uppercase fs-12">
                                              Lọc theo:{" "}
                                            </span>
                                            <span className="text-muted">
                                          Tuần này
                                          <i className="mdi mdi-chevron-down ms-1"></i>
                                        </span>
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-end">
                                            <DropdownItem href="#">Tất cả</DropdownItem>
                                            <DropdownItem href="#">Nguyễn Văn A</DropdownItem>
                                            <DropdownItem href="#">Nguyễn Văn B</DropdownItem>
                                            <DropdownItem href="#">Nguyễn Văn C</DropdownItem>
                                            <DropdownItem href="#">Nguyễn Văn D</DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <ReactApexChart dir="ltr"
                                options={options}
                                series={series}
                                type="bar"
                                height="436"
                                className="apex-charts"
                            />
                        </CardBody>
                    </Card>
                </div>
            </div>
        </React.Fragment>
    );
};

export default OrderReportEfficiency;
